import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog as HeadlessDialog } from '@flywire/react-headlessui';
import { cx } from '../../utils';
const sizeClasses = {
    small: 'w-full lg:max-w-sm',
    medium: 'w-full lg:max-w-md',
    large: 'w-full lg:max-w-xl'
};
export const usePanelClasses = ({ className, size }) => {
    return cx('overflow-y-auto rounded bg-white p-6 shadow-lg', size && sizeClasses[size], className);
};
const Panel = forwardRef(({ className, size = 'medium', ...rest }, ref) => {
    const panelClasses = usePanelClasses({ className, size });
    return (_jsx("div", { className: "fixed inset-0 z-10 w-screen overflow-y-auto", children: _jsx("div", { className: "flex min-h-full items-end justify-center p-4 text-center lg:items-center lg:p-0", children: _jsx(HeadlessDialog.Panel, { ref: ref, className: panelClasses, ...rest }) }) }));
});
Panel.displayName = 'Panel';
export { Panel };
//# sourceMappingURL=Panel.js.map